import { CloseOutlined } from "@ant-design/icons";
import { Button, Modal, ModalProps, Typography } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";

interface IProps extends ModalProps
{
  title: React.ReactNode | string;
  open: boolean;
  toggle: () => void;
  handleConfirm?: () => void;
  children?: React.ReactNode | string;
  hiddenFooter?: boolean;
  disabled?: boolean;
  style?: any;
  width?: number | string;
  confirmText?: React.ReactNode;
  extraFooter?: React.ReactNode;
}
const ModalUI = (props: IProps) =>
{
  //! state
  const {
    open,
    title,
    toggle,
    handleConfirm,
    hiddenFooter,
    children,
    disabled,
    style,
    width,
    confirmText,
    extraFooter,
    ...res
  } = props;

  const { t } = useTranslation();
  return (
    <Modal
      title={
        <Typography.Title level={4} className="!text-[var(--color-label-form)]">
          {title ?? "Notification"}
        </Typography.Title>
      }
      open={open}
      centered
      width={width ?? "auto"}
      onCancel={toggle}
      closeIcon={
        <div onClick={toggle}>
          <CloseOutlined className="text-[var(--color-label-form)]" />
        </div>
      }
      maskClosable={false}
      styles={{ ...style }}
      footer={() =>
        hiddenFooter ? null : (
          <>
            <Button
              className="h-8 w-[100px] rounded btn-outline"
              onClick={toggle}
            >
              {t("No")}
            </Button>
            {extraFooter}
            <Button
              className="h-8 w-[100px]  btn-primary rounded"
              onClick={handleConfirm}
              loading={res?.loading}
              disabled={disabled}
            >
              {confirmText ?? t("Yes")}
            </Button>
          </>
        )
      }
      className="rounded-lg"
      {...res}
    >
      <div className="text-[var(--color-label-form)] pt-3">{children}</div>
    </Modal>
  );
};

export default ModalUI;
